import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";

function AnnualExamSchedule() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, [token, navigate]);

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-2">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-calendar" />
                    &nbsp;Annual Exam Schedule
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Annual Exam Schedule</li>
                  </ol>
                </section>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="card">
                  <div className="card-header bg-primary">
                    <h5 className="mb-0 p-2 text-white">Annual Exam Schedule</h5>
                  </div>
                  <div className="card-body text-center py-5">
                    <i className="fa fa-calendar-o fa-3x text-muted mb-3" />
                    <h4 className="text-muted">Annual Exam Schedule Details</h4>
                    <p className="text-muted mb-0">This section is currently not available.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default AnnualExamSchedule;
